import React from "react";

function ResidencialPlaceHolderIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="59"
      fill="none"
      viewBox="0 0 50 59"
    >
      <rect
        width="49.105"
        height="58.584"
        y="0.019"
        fill="#1C64F2"
        fillOpacity="0.08"
        rx="8"
      ></rect>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20.563 40.565c-1.422-2.421-2.258-5.366-2.258-8.547 0-4.118 2.797-7.456 6.247-7.456 3.45 0 6.246 3.338 6.246 7.456"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20.563 40.565c-1.422-2.421-2.258-5.366-2.258-8.547 0-4.118 2.797-7.456 6.247-7.456 3.45 0 6.246 3.338 6.246 7.456"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M31.138 39.455c-.113.008-.223.02-.336.02-3.45 0-6.247-3.338-6.247-7.456"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M31.138 39.455c-.113.008-.223.02-.336.02-3.45 0-6.247-3.338-6.247-7.456"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M25.851 41.516c-2.654-1.975-4.422-5.49-4.422-9.497 0-2.06 1.4-3.729 3.124-3.729 1.725 0 3.124 1.67 3.124 3.729s1.4 3.728 3.124 3.728c1.725 0 3.124-1.67 3.124-3.728 0-6.178-4.196-11.185-9.37-11.185-5.176 0-9.371 5.007-9.371 11.185 0 1.377.129 2.718.366 4.01"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M25.851 41.516c-2.654-1.975-4.422-5.49-4.422-9.497 0-2.06 1.4-3.729 3.124-3.729 1.725 0 3.124 1.67 3.124 3.729s1.4 3.728 3.124 3.728c1.725 0 3.124-1.67 3.124-3.728 0-6.178-4.196-11.185-9.37-11.185-5.176 0-9.371 5.007-9.371 11.185 0 1.377.129 2.718.366 4.01"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M33.276 21.82c-2.13-2.887-5.245-4.715-8.722-4.715-3.477 0-6.592 1.828-8.722 4.715"
      ></path>
      <path
        stroke="#1C64F2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M33.276 21.82c-2.13-2.887-5.245-4.715-8.722-4.715-3.477 0-6.592 1.828-8.722 4.715"
      ></path>
    </svg>
  );
}

export default ResidencialPlaceHolderIcon;
